<template>
  <div style="background-color: white;">
    <!--    <div style="background-color: white;overflow:hidden;">-->
    <!--      <h1 class="g-hd">-->
    <!--        医院药品退货进度-->
    <!--      </h1>-->
    <!--    </div>-->
    <div>
      <van-icon name="arrow-left" style="float: left;margin-top: 15px;margin-left: 15px" @click="onClick()"/>
      <van-cell style="width: 310px;float: left" title="医院药品退货进度" size="large" value=""/>
    </div>
    <div style="width: 210px; margin-left: 30px;">
      <van-steps active-color="#2984F3" active-icon="success" direction="vertical" :active="active">
<!--        <div style="float: left" v-for="(item,index) in step" :key="index">-->
<!--          <van-step>-->
<!--            <span>{{ item.statusName }}</span>-->
<!--            <p>{{ item.statusTime}}</p>-->
<!--          </van-step>-->
<!--        </div>-->
        <div style="float: left">
          <van-step>
            <span>{{ step[0].statusName }}</span>
            <p>{{ step[0].statusTime }}</p>
          </van-step>
          <van-step>
            <span>{{ step[1].statusName }}</span>
            <p>{{ step[1].statusTime }}</p>
          </van-step>
          <van-step>
            <span>{{ step[2].statusName }}</span>
            <p>{{ step[2].statusTime }}</p>
          </van-step>
          <van-step>
            <span>{{ step[3].statusName }}</span>
            <p>{{ step[3].statusTime }}</p>
          </van-step>
          <van-step>
            <span>{{ step[4].statusName }}</span>
            <p>{{ step[4].statusTime }}</p>
          </van-step>
          <van-step>
            <span>{{ step[5].statusName }}</span>
            <p>{{ step[5].statusTime==null?null:step[5].statusTime }}</p>
          </van-step>
        </div>
      </van-steps>
    </div>
    <div>
      <van-cell-group>
        <van-cell class="van-cell" title="退货单号" :value="orderReturn.returnNo"/>
        <van-cell title="退货品规" :value="orderReturn.drugNumber"/>
        <van-cell title="退货数量" :value="orderReturn.totalNumber"/>
        <van-cell title="申请单位" value="澳洋医院"/>
        <van-cell title="退货单属性" :value="orderReturn.type"/>
      </van-cell-group>
    </div>
  </div>

</template>

<script>
import api from "@/axios/api";
import {mapGetters, mapActions} from "vuex";

export default {
  name: "orderReturnStep",
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function(val) {
        this.returnNo = this.$route.query.returnNo;
        //this.initDrugInfo();
        if (val) {
          this.initDrugInfo();
        }
      }
    }
  },
  data() {
    return {
      active: 0,
      returnNo:'',
      orderReturn : [],
      step:[]
    }
  },
  mounted(){
    this.returnNo = this.$route.query.returnNo;
  },
  methods:{
    //页面初始化时加载数据方法
    initDrugInfo(){
      let params = {
        returnNo:this.returnNo
      }

      api.getStepByReturnNo(params).then((res) =>{
        if (res.success){
          this.step = res.result;
          for (let i=0;i<res.result.length;i++){
            if (res.result[i].statusTime!=null){
              this.active++;
              console.log("active:"+this.active)
            }
          }
          this.active = this.active-1;
        }
      })

      api.getOrderReturnByReturnNo(params).then((res) => {
        if (res.success){
          this.orderReturn = res.result;
        }
      })
    },
    onClick(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
.g-hd {
  display: inline;
  float: left;
  font-size: 20px;
  font-weight: lighter;
  font-style: normal;
  background-color: white;
  margin-left: 3%;
  overflow: hidden;
}

.van-cell__title {
  text-align: left;
}

.van-cell--large{
  padding-left: 0px;
}


</style>



// WEBPACK FOOTER //
// src/spd/orderReturnStep.vue